<template>
  <form
    @submit="onSubmit"
  >
    <div
      class="modal fade"
      id="private"
      tabindex="-1"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div>
            <VideoControls
              ref="refVideoControls"
              :videosrc="videoSrc"
              :poster="videoCover"
              :autoplay="true"
              :nextVideo="nextVideo"
              :previousVideo="previousVideo"
              :showNextVideo="showNextVideo"
              :showPreviousVideo="showPreviousVideo"
              :videoResolutionList="videoList"
              :changeResolution="changeResolution"
              :error="onError"
              :ready="onReady"
              :end="onEnd"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import { h , ref , toRefs , reactive , watch , inject , onMounted , onBeforeUpdate , onUpdated} from 'vue';
import { oltConsole, oAA , oApiError , oAdminFrame } from '@/lib/oltModule/initAdminVue3';
import moment from 'moment' ;
import { useI18n } from 'vue-i18n';
import { useForm, useField } from 'vee-validate';
import 'vue3-eggplant/dist/style.css';
import { VideoJS, VideoControls } from '@/components/VideoPlayer' ;

//import vue3videoPlay from "vue3-eggplant";
//import "vue3-eggplant/dist/style.css";

import 'vue3-video-play/dist/style.css';

import * as yup from 'yup';
export default {
  components: {
    // VideoJS,
    VideoControls,
  },
  props:{
    // apiName: {
    //   type: String ,
    //   required:true
    // },    
    // pkyKey: {
    //   type: String ,
    //   required:true
    // },       
    privatePkyId: {
      type: String ,
      required:true
    }
  },
  emits: ['privateCallBack'],
  setup(props,{emit}) {
  
    
    /*
	const options = reactive({
	  src: "",
	  type: "m3u8", 
	});*/

    const refVideoControls = ref();
    const videoSrc = ref('');
    const videoCover = ref('');
    const videoList = ref([]);
    const showPreviousVideo = ref(false);
    const showNextVideo = ref(false);

    const options = reactive({
      width: '800px', //播放器高度
      height: '450px', //播放器高度
      color: '#409eff', //主题色
      title: '', //视频名称
      src: '',
      type: 'm3u8', 
      muted: false, //静音
      webFullScreen: false,
      quality: ['1080P', '720P'],
      //speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
      autoPlay: true, //自动播放
      loop: false, //循环播放
      mirror: false, //镜像画面
      ligthOff: false, //关灯模式
      volume: 0.3, //默认音量大小
      control: true, //是否显示控制
      controlBtns: [
        'audioTrack',
        // "quality",
        'speedRate',
        'volume',
        'setting',
        'pip',
        'pageFullScreen',
        'fullScreen',
      ], //显示所有按钮,
    });
	
    const onPlay = (ev) => {
      //console.log("播放");
    };
    const onPause = (ev) => {
      //console.log(ev, "暂停");
    };

    const onTimeupdate = (ev) => { 
  
    };
    const onCanplay = (ev) => {
      //console.log(ev, "可以播放");
    };
    /**
     *  swal start
     */
    const swal = inject('$swal') ;
    /**
     *  swal end 
     */

    /**
     *  i18n Start 
     */
    const { t, locale } = useI18n({
      useScope:'global' // 必需設定 SCOPE 才能覆蓋設定
    }); 

    locale.value = 'zh-TW';
    /**
     *  i18n end 
     */

    const schema = yup.object({
      name: yup.string()
        .min(2,t('messages.min',{length:2}))
        .max(32,t('messages.max',{length:32}))        
        .required(t('messages.required')),
      // code: yup.string()
      //   .min(2,t('messages.min',{length:2}))
      //   .max(32,t('messages.max',{length:32}))        
      //   .required(t('messages.required')),              
      // description: yup.string()
      //   .nullable(true)
      //   .min(4,t('messages.min',{length:4}))
      //   .max(255,t('messages.max',{length:255})),
      seq: yup.number()
        .typeError('：必需為數字！')
        .nullable(true)
        .min(1,'：最少為 1 ')
        .max(2147483647,'：最多為 2147483647')
        .required('：為必填欄位！'),
    });
    // Create a form context with the validation schema

    const { handleSubmit , resetForm } = useForm({
      validationSchema: schema,
    });
    // No need to define rules for fields
    const { value: name, errorMessage: nameError , meta: nameMeta , resetField: nameResetField } = useField('name');
    // const { value: code, errorMessage: codeError , meta: codeMeta , resetField: codeResetField } = useField('code');
    // const { value: description, errorMessage: descriptionError , meta: descriptionMeta, resetField: descriptionResetField } = useField('description');
    const { value: seq, errorMessage: seqError , meta:seqMeta , resetField: seqResetField } = useField('seq');
    /* switch 是 關鍵字 要加 switchStatus */
    const { value: switchStatus, errorMessage: switchError , meta:switchMeta , resetField: switchResetField } = useField('switch');

	  let videoElement;


    /**
     *  getOneRecord Start
     */
    // eslint-disable-next-line no-unused-vars
    const { privatePkyId } = toRefs(props);


    getOneRecord(privatePkyId.value);
    watch(privatePkyId, (newValue, oldValue) => {
      //console.log('show privatePkyId : ', newValue);
      // console.log('show privatePkyId : ', privatePkyId.value);
      getOneRecord(newValue);

    }) ;

    const oneRecord = ref({});

    function getOneRecord(pkyId){
      // console.log('getOneRecord');
      if(pkyId && refVideoControls.value ){
        videoSrc.value = pkyId;
        
        // console.log('videoSrc.value ==> ', videoSrc.value);
      }
      // console.log('pkyId: ', pkyId);
      //options.src = pkyId;
      if(pkyId > 0){
	  
	  
      }
    }
    /**
     *  getOneRecord End
     */

    // 初始化 表單的值
    function initForm(){
	
	
    }
	

    // use `onSubmit` as an event handler for your forms
    const onSubmit = handleSubmit(values => {
      // pretty print the values object
      //console.log('onSubmit');
      //console.log('onSubmit : ',values);
      //   putOneRecord(values);
    });
	
    function submitModalPage(e){
	
      let videoElementidEl = document.getElementById('videoElementid');
	   
      if(videoElementidEl)
      {
        //this.videoElement.pause();//暂停
        videoElementidEl.pause();//暂停
      }

      // console.log('refVideoJS');
      let state = {
        pause : true
      };
      refVideoControls.value.onPlayStop();
      // refVideoControls.value.pause();
	
	
    }

        // 播放器 Event Start -------------------

    function onReady(){
      ////console.log("onReady");
      // eslint-disable-next-line no-undef
    }

    function onEnd(){
      if(refVideoControls.value){
        // 更新最後播放時間
        refVideoControls.value.onChangeLastcurrenttime(0);  
      } 
      // console.log("BBB");
      currentTime.value = 0;
      nextVideo();
    }

    function onLag(){      
      // console.log("onLag");
      let time = currentTime.value;
      // 取得影片紀錄
      let record = oUserInfo.getCurrentVideo(store);
      if(record != null && record.currentTime != null){
        time = record.currentTime;
      }
      // 紀錄當前播放時間
      let videoData = {
        lid: pageSearchLid.value,
        kpid: pageSearchKpid.value,
        pid: pageSearchPid.value,
        currentTime: time,
      };
      // console.log("onLag currentTime:", time);
      oUserInfo.setCurrentVideo(store, videoData);
      oltCookie.setCookie('super_meta_api_next', "Y");
      videoLoadingText.value = '網路偵測異常緩衝中，請稍等。';
      isVideoLoading.value = true;
      getSuperMetaVideo();
    }

    function onError(value){
      console.log("onError value: ", value);
      isCanPlay.value = false;
      clearCountTime();
      countTimer.value = null;
      swal.fire({
        icon:'error',
        html:'影片播放失敗，請聯繫客服人員協助處理<br>服務專線：02-6635 5889',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        confirmButtonText:t('messages.confirm_button'),
      }).then(() => {
      });
    }
    // 播放器 Event Start -------------------
	 
    // 播放器 Function Start -------------------

    function nextVideo(){
      // 關閉影片計時器
      clearCountTime();
      // 紀錄當前影片觀看時間
      postHistoryUserLesson(pageSearchPlid.value, pageSearchOiid.value, pageSearchLid.value, pageSearchPid.value, pageSearchKpid.value, currentTime.value, countTime.value);
      // 取得下一部影片 ==== Start ====
      if((currKnowledgeIndex.value + 1) < recordData.value[currParagraphIndex.value].knowledgeList.length) {
        // 該段落還有下一個知識點
        currKnowledgeIndex.value += 1;
        if(recordData.value != null && recordData.value[currParagraphIndex.value].knowledgeList != null && 
            recordData.value[currParagraphIndex.value].knowledgeList.length > 0) {
          getVodList(currParagraphIndex.value, 
            currKnowledgeIndex.value, 
            recordData.value[currParagraphIndex.value].knowledgeList.length, false);
        }            
      }else{    
        // 轉跳至下一段落第一個知識點
        if ((currParagraphIndex.value+1) < recordData.value.length){
          // 將下一個段落展開
          let res = showParagraph(currParagraphIndex.value + 1);

          if(res == true){
            // 展開成功更新段落Index
            currParagraphIndex.value += 1;
            // 展開成功更新知識點Index
            currKnowledgeIndex.value = 0;
            if(recordData.value != null && recordData.value[currParagraphIndex.value].knowledgeList != null && 
                recordData.value[currParagraphIndex.value].knowledgeList.length > 0) {
              getVodList(currParagraphIndex.value, 
                currKnowledgeIndex.value, 
                recordData.value[currParagraphIndex.value].knowledgeList.length, false);
            }  
          }
        } 
      }
      // 取得下一部影片 ==== End ====
    }

    function showParagraph(index){
      // 隱藏全部段落
      $('.video-paragrap').each(function(){
        $(this).attr('aria-expanded', 'false');
        if($(this).hasClass('collapsed') == false){
          $(this).addClass('collapsed');
        }
      });
      $('.video-knowledge').each(function(){
        if($(this).hasClass('show') == true){
          $(this).removeClass('show');
        }
      });
      // 開啟指定段落
      $(`#bpanel-${index}`).click();
      return true;
    }

    function previousVideo(){
      // 關閉影片計時器
      clearCountTime();
      // 紀錄當前影片觀看時間
      postHistoryUserLesson(pageSearchPlid.value, pageSearchOiid.value, pageSearchLid.value, pageSearchPid.value, pageSearchKpid.value, currentTime.value, countTime.value);
      // 取得上一部影片 ==== Start ====
      if(currKnowledgeIndex.value > 0) {
        // 該段落還有上一個知識點
        currKnowledgeIndex.value -= 1;
        if(recordData.value != null && recordData.value[currParagraphIndex.value].knowledgeList != null && 
            recordData.value[currParagraphIndex.value].knowledgeList.length > 0) {
          getVodList(currParagraphIndex.value, 
            currKnowledgeIndex.value, 
            recordData.value[currParagraphIndex.value].knowledgeList.length, false);
        }            
      }else{    
        // 轉跳至上一段落最後一個知識點
        if ((currParagraphIndex.value-1) >= 0){
          // 將上一個段落展開
          let res = showParagraph(currParagraphIndex.value - 1);

          if(res == true){
            // 展開成功更新段落Index
            currParagraphIndex.value -= 1;
            // 展開成功更新知識點Index
            currKnowledgeIndex.value = recordData.value[currParagraphIndex.value].knowledgeList.length - 1;
            if(recordData.value != null && recordData.value[currParagraphIndex.value].knowledgeList != null && 
              recordData.value[currParagraphIndex.value].knowledgeList.length > 0) {
              getVodList(currParagraphIndex.value, 
                currKnowledgeIndex.value, 
                recordData.value[currParagraphIndex.value].knowledgeList.length, false);
            } 
          }
        } 
      }
      // 取得上一部影片 ==== End ====
    }
    // 播放器 Function End -------------------

    function changeResolution(item, time){
      //console.log("[changeResolution] item ==> ", item);
      if(refVideoControls.value){
        // 更新最後播放時間
        refVideoControls.value.onChangeLastcurrenttime(time);  
      } 
      if(refVideoControls.value){
        // 更新解析度
        refVideoControls.value.videoResolution = item.videoResolution;  
      } 
      // 關閉影片計時器
      clearCountTime();
      // 紀錄當前影片觀看時間
      postHistoryUserLesson(pageSearchPlid.value, pageSearchOiid.value, pageSearchLid.value, pageSearchPid.value, pageSearchKpid.value, currentTime.value, countTime.value);          
      // 重新取得影片
      getSuperMetaVideo();
    }

    function clearCountTime(){
      if(countTimer.value){
        // eslint-disable-next-line no-undef
        clearInterval(countTimer.value);
      }
      countTimer.value = null;
    }


    /**
     *  修改新增資料 在 刷新時重新初始化 material dashboard 的 js 設定 
     *  initAdmion.js Start
     */
    onUpdated( async () => {
      await oAdminFrame.initMdInput() ;
    }) ;
    onMounted( async () => {
      // eslint-disable-next-line no-undef
      await oAdminFrame.initMdInput() ;
	  
	  
      let privateEl = document.getElementById('private');
      // console.log('privateEl',privateEl)

	  if (privateEl) {
        privateEl.addEventListener('hidden.bs.modal', function (e) {
          // console.log("#暂停#");   
		      submitModalPage(e);
        });
	  }
	  
	  
    });

    
    function onVideoJSMounted(){
      // initVideoJS();
      // nextTick(() => {
      //   refVideoJS.value.setVideoSrc(videoSrc.value);
      //   console.log('refVideoJS1',refVideoJS.value);
      // });
      // console.log('videoSrc.value', videoSrc.value);

      //執行播放
      onVideoReady();
    }   


    function onVideoError(){
    }
    function onVideoReady(){
    }
    function onVideoEnded(){
    }
    function playerStatusChange(state){
    }
    function onVideoTimeupdate(time, isSlider){
    }
    function onVideoDurationchange(time){
    }
    function onVideoFullscreenchange(isFull){
    }
    function onVideoCanplaythrough(){
    }

    /**
     *  initAdmion.js End
     */

    return {
      // moment 
      moment,
      // i18n
      t,
      locale,      
      // add form
      oneRecord,
      name,
      nameError,
      nameMeta,
      // code,
      // codeError,
      // codeMeta,      
      // description,
      // descriptionError,
      // descriptionMeta,      
      seq,
      seqError,
      seqMeta,
      switchStatus,
      switchError,
      switchMeta,
      onSubmit,
      options,
      submitModalPage,
      videoElement,
      onPlay,
      onPause,
      onTimeupdate,
      onCanplay,

      onVideoJSMounted,
      onVideoError,
      onVideoReady,
      onVideoEnded,
      playerStatusChange,
      onVideoTimeupdate,
      onVideoDurationchange,
      onVideoFullscreenchange,
      onVideoCanplaythrough,
      changeResolution,
      // Component Video Params
      videoSrc,
      videoCover,
      videoList,
      //ref
      refVideoControls,
      // Function
      onReady,
      onEnd,
      onError,
      onLag,
      nextVideo,
      previousVideo,
      // const data
      showPreviousVideo,
      showNextVideo,

    };
  },
};

 
	  
</script>

<style lang="scss" scoped>


.outer {
  /*background-color: #95afba;*/
  position: relative; /* ★ */
  /*height: 800px;*/
  display: flex; /* ★ */
  align-items: center; /* ★ */
}

.inner {
 /* background-color: #d5e1a3;*/
 /* height: 600px;*/
}



</style>